import {httpUrl} from './httpUrl'

// let baseUrl = `${httpUrl.host}/kj-gy-apartment`
// let baseUrl2 = `${httpUrl.host}/kj-gy-apartment`
// let baseUrl3 = `${httpUrl.host}/kj-gy-apartment`
let baseUrl = `${httpUrl.host}/gy-lease`
let baseUrl2 = `${httpUrl.host}/gy-finance`
let baseUrl3 = `${httpUrl.host}/gy-hatch`

let api = {
  // 删除合同模板
  deleteContractTemplateByCodes: `${baseUrl}/contractTemplate/deleteByCodes`,

  // 下载合同模板
  downloadContractTemplate: `${baseUrl}/contractTemplate/download`,

  // 预览合同模板
  getContractTemplateByCode: `${baseUrl}/contractTemplate/getByCode`,

  // 获取合同分页
  getContractTemplatePage: `${baseUrl}/contractTemplate/getPage`,

  // 上传合同模板
  uploadContractTemplate: `${baseUrl}/contractTemplate/upload`,

  // 删除通知单模板
  deleteNoticeTemplateByCodes: `${baseUrl2}/template/delete`,

  // 下载通知单模板
  downloadNoticeTemplate: `${baseUrl2}/template/download`,

  // 预览通知单模板
  getNoticeTemplateByCode: `${baseUrl2}/template/getByCode`,

  // 获取通知单分页
  getNoticeTemplatePage: `${baseUrl2}/template/getPage`,

  // 上传通知单模板
  uploadNoticeTemplate: `${baseUrl2}/template/upload`,

  // 获取协议分页
  getHatchTemplatePage: `${baseUrl3}/protocolTemplate/getPage`,

  // 删除协议
  deleteHatchTemplateByCodes: `${baseUrl3}/protocolTemplate/deleteByCodes`,

  // 上传协议模板
  uploadHatchTemplate: `${baseUrl3}/protocolTemplate/upload`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/SetFocus.js